.container {
	display: flex;
	flex-direction: column;
}

.main {
	flex: 1;
	display: flex;
	align-items: stretch;
	min-width: 0;
	overflow: hidden;
}

.app {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	box-sizing: border-box;
	flex: 1 0 auto;
	font-family: BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans',
		'Droid Sans', 'Helvetica Neue', sans-serif;
}

.roadmap {
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;
}

.legend {
	display: flex;
	width: 240px;
	flex-shrink: 0;

	margin-left: -1px;
	z-index: 1;
}
